import React from 'react'
import { Outlet } from 'react-router-dom'
function DashOutlet() {
  return (
    <div> <Outlet/> <br/></div>
  )
}

export default DashOutlet